import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.hyperauth.app",
  timeout: 1000,
  headers: { "Content-Type": "application/json" },
});

export default instance;
